export default "__VITE_ASSET__4yTyOEwZ__"